<svg-icon *ngIf="iconURL" [svgPath]="iconURL" [attr.aria-label]="title" class="box-empty-state-icon"></svg-icon>
<div class="box-empty-state-content ods-typography-body-s-bold">
  <div *ngIf="title">{{ title | translate }}</div>
  <div *ngIf="description">{{ description | translate }}</div>
</div>
